<template>
	<v-col class="history-transfer">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Pertumbuhan Jaringan</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-account-group</v-icon>
			<div class="pl-2">Jaringan</div>
			<div class="px-2">/</div>
			<div>Pertumbuhan Jaringan</div>
		</div>
		
		<div class="mt-5 mb-5 pb-5" v-if="Object.keys(netGrowthToday).length > 0">
			<h3 class="mb-5">Pertumbuhan Jaringan Hari Ini</h3>
			<div class="d-none d-md-flex flex-row align-center justify-center">
				<div class="d-flex flex-grow-1 flex-shrink-1 mr-2">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-lg text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Point Kiri</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netGrowthToday.node_left > 0) ? 'primary--text' : 'grey--text'">{{ netGrowthToday.node_left | toNumber }}</div>
						</div>
					</v-card>
				</div>

				<div class="d-flex flex-grow-1 flex-shrink-1 mx-2">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-lg text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Point Kanan</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netGrowthToday.node_right > 0) ? 'primary--text' : 'grey--text'">{{ netGrowthToday.node_right | toNumber }}</div>
						</div>
					</v-card>
				</div>

				<div class="d-flex flex-grow-1 flex-shrink-1 mx-2">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-lg text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Menunggu <span class="d-block font-weight-600">Kiri</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netGrowthToday.wait_left > 0) ? 'primary--text' : 'grey--text'">{{ netGrowthToday.wait_left | toNumber }}</div>
						</div>
					</v-card>
				</div>

				<div class="d-flex flex-grow-1 flex-shrink-1 mx-2">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-lg text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Menunggu <span class="d-block font-weight-600">Kanan</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netGrowthToday.wait_right > 0) ? 'primary--text' : 'grey--text'">{{ netGrowthToday.wait_right | toNumber }}</div>
						</div>
					</v-card>
				</div>

				<div class="d-flex flex-grow-1 flex-shrink-1 mx-2">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-lg text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Pasangan</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netGrowthToday.node_match > 0) ? 'primary--text' : 'grey--text'">{{ netGrowthToday.node_match | toNumber }}</div>
						</div>
					</v-card>
				</div>

				<div class="d-flex flex-grow-1 flex-shrink-1 mx-2">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-lg text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Unilevel</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netGrowthToday.node_match > 0) ? 'primary--text' : 'grey--text'">{{ netGrowthToday.node_unilevel | toNumber }}</div>
						</div>
					</v-card>
				</div>

				<div class="d-flex flex-grow-1 flex-shrink-1 ml-2">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-lg text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Sponsor</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netGrowthToday.node_match > 0) ? 'primary--text' : 'grey--text'">{{ netGrowthToday.node_sponsor | toNumber }}</div>
						</div>
					</v-card>
				</div>
			</div>

			<v-row class="ml-0 d-flex d-md-none">
				<v-col cols="6" sm="4" class="pl-0">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-lg text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Point Kiri</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netGrowthToday.node_left > 0) ? 'primary--text' : 'grey--text'">{{ netGrowthToday.node_left | toNumber }}</div>
						</div>
					</v-card>
				</v-col>

				<v-col cols="6" sm="4" class="pl-0">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-lg text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Point Kanan</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netGrowthToday.node_right > 0) ? 'primary--text' : 'grey--text'">{{ netGrowthToday.node_right | toNumber }}</div>
						</div>
					</v-card>
				</v-col>

				<v-col cols="6" sm="4" class="pl-0">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-lg text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Menunggu <span class="d-block font-weight-600">Kiri</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netGrowthToday.wait_left > 0) ? 'primary--text' : 'grey--text'">{{ netGrowthToday.wait_left | toNumber }}</div>
						</div>
					</v-card>
				</v-col>

				<v-col cols="6" sm="4" class="pl-0">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-lg text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Menunggu <span class="d-block font-weight-600">Kanan</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netGrowthToday.wait_right > 0) ? 'primary--text' : 'grey--text'">{{ netGrowthToday.wait_right | toNumber }}</div>
						</div>
					</v-card>
				</v-col>

				<v-col cols="6" sm="4" class="pl-0">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-lg text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Pasangan</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netGrowthToday.node_match > 0) ? 'primary--text' : 'grey--text'">{{ netGrowthToday.node_match | toNumber }}</div>
						</div>
					</v-card>
				</v-col>

				<v-col cols="6" sm="4" class="pl-0">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-lg text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Unilevel</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netGrowthToday.node_match > 0) ? 'primary--text' : 'grey--text'">{{ netGrowthToday.node_unilevel | toNumber }}</div>
						</div>
					</v-card>
				</v-col>

				<v-col cols="6" sm="4" class="pl-0">
					<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-lg text-center d-flex flex-column align-stretch h-100 w-100" height="100">
						<div class="d-block cl-secondary font-size-10 font-weight-500">Penambahan <span class="d-block font-weight-600">Sponsor</span></div>
						<div class="d-flex flex-column align-center justify-center py-1">
							<div class="font-size-20 font-weight-600" :class="(netGrowthToday.node_match > 0) ? 'primary--text' : 'grey--text'">{{ netGrowthToday.node_sponsor | toNumber }}</div>
						</div>
					</v-card>
				</v-col>
			</v-row>
		</div>

		<div class="mt-5">
			<v-row justify="end">
				<v-col cols="12" sm="11" md="8" xl="5" class="py-0 py-sm-3">
					<v-row justify="end">
						<v-col cols="6" sm="4" md="4" class="pr-2 pr-sm-0">
							<v-menu v-model="startDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field placeholder="Dari Tanggal" outlined dense append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" background-color="white" class="rounded-lg date-no-border" hide-details :value="convertDate(start)"></v-text-field>
								</template>
								<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="startDate = false" @change="endDate = null, end = null" v-model="start"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="6" sm="4" md="4" class="pl-1 pl-sm-3 pr-sm-0 pr-xl-2">
							<v-menu v-model="endDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field placeholder="Sampai Tanggal" outlined dense append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" background-color="white" class="rounded-lg date-no-border" hide-details :value="convertDate(end)"></v-text-field>
								</template>
								<v-date-picker locale="id" first-day-of-week="0" color="primary" :min="start" :max="today" @input="endDate = false" v-model="end"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" sm="3" md="3" class="pt-0 pt-sm-3">
							<div class="d-none d-md-flex justify-end">
								<v-btn depressed height="40" color="primary" class="white--text rounded-lg text-capitalize" @click="seacrhHistory">Cari</v-btn>
								<v-btn depressed height="40" color="grey lighten-1" class="ml-3 white--text rounded-lg text-capitalize" @click="resetHistory">Reset</v-btn>
							</div>

							<div class="d-flex d-md-none flex-row">
								<v-btn depressed height="40" color="primary" class="d-flex flex-grow-1 flex-shrink-1 mx-1 white--text rounded-lg text-capitalize" @click="seacrhHistory">Cari</v-btn>
								<v-btn depressed height="40" color="grey lighten-1" class="d-flex flex-grow-1 flex-shrink-1 mx-1 white--text rounded-lg text-capitalize" @click="resetHistory">Reset</v-btn>
							</div>
						</v-col>
					</v-row>
				</v-col>
			</v-row>

			<div class="mt-3" v-if="!loading">
				<v-row v-if="listNetGrowth.length > 0">
					<v-col cols="12" class="pt-0 d-none d-md-block">
						<v-simple-table dense class="white-row table-vo table-history-bonus" id="table-netgrowth">
							<template v-slot:default>
								<thead class="grey lighten-2 font-weight-500">
									<tr>
										<th class="text-left py-3" rowspan="2" width="18%">Tanggal</th>
										<th class="text-center mb-0 py-3" colspan="2" width="26%">Penambahan Point</th>
										<th class="text-center mb-0 py-3" colspan="2" width="26%">Menunggu</th>
										<th class="text-center py-3" rowspan="2" width="10%">Pasangan</th>
										<th class="text-center py-3" rowspan="2" width="10%">Unilevel</th>
										<th class="text-center py-3" rowspan="2" width="10%">Sponsor</th>
									</tr>
									<tr class="grey lighten-1">
										<th class="text-center py-3"><v-icon small color="primary">mdi-arrow-left</v-icon> Kiri</th>
										<th class="text-center py-3">Kanan <v-icon small color="primary">mdi-arrow-right</v-icon></th>
										<th class="text-center py-3"><v-icon small color="primary">mdi-arrow-left</v-icon> Kiri</th>
										<th class="text-center py-3">Kanan <v-icon small color="primary">mdi-arrow-right</v-icon></th>
									</tr>
								</thead>
							</template>
						</v-simple-table>

						<v-simple-table dense class="white-row table-vo table-history-bonus">
							<template v-slot:default>
								<tbody class="grey--text text--darken-3">
									<tr v-for="netGrowth in listNetGrowth" :key="netGrowth.netgrow_master_id" class="mb-5">
										<td class="text-left" width="18%">
											<div class="d-flex flex-wrap">
												<div class="font-size-20 font-weight-500 primary--text">{{ netGrowth.netgrow_master_date | toTanggal }}</div>
												<div class="pl-2 font-size-10 my-auto">
													<div>{{ netGrowth.netgrow_master_date | bulan }}</div>
													<div>{{ netGrowth.netgrow_master_date | tahun }}</div>
												</div>
											</div>
										</td>
										<td class="text-center" width="13%">
											<div>{{ netGrowth.netgrow_master_node_left | toNumber }}</div>
										</td>
										<td class="text-center" width="13%">
											<div>{{ netGrowth.netgrow_master_node_right | toNumber }}</div>
										</td>
										<td class="text-center" width="13%">
											<div>{{ netGrowth.netgrow_master_wait_left | toNumber }}</div>
										</td>
										<td class="text-center" width="13%">
											<div>{{ netGrowth.netgrow_master_wait_right | toNumber }}</div>
										</td>
										<td class="text-center" width="10%">{{ netGrowth.netgrow_master_match_real | toNumber }}</td>
										<td class="text-center" width="10%">{{ netGrowth.netgrow_master_unilevel | toNumber }}</td>
										<td class="text-center" width="10%">{{ netGrowth.netgrow_master_sponsor | toNumber }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>

					<v-col cols="12" class="my-3 d-block d-md-none">
						<template v-for="netGrowth in listNetGrowth">
							<v-card class="pa-3 mb-2 elevation-0 hover-shadow rounded-lg d-flex flex-row align-start w-100" :key="netGrowth.netgrow_master_id">
								<v-row>
									<v-col cols="4">
										<div class="d-flex flex-column">
											<div class="font-size-22 font-weight-500 primary--text">{{ netGrowth.netgrow_master_date | toTanggal }}</div>
											<div class="font-size-10 my-auto">
												<div>{{ netGrowth.netgrow_master_date | bulan }}</div>
												<div>{{ netGrowth.netgrow_master_date | tahun }}</div>
											</div>
										</div>
									</v-col>

									<v-col cols="8" class="pl-0">
										<div class="d-flex justify-space-between align-start mb-1">
											<label class="cl-black font-size-9 font-weight-bold">Point Kiri</label>
											<span class="cl-black font-size-10">{{ netGrowth.netgrow_master_node_left | toNumber }}</span>
										</div>

										<div class="d-flex justify-space-between align-start mb-1">
											<label class="cl-secondary font-size-9 font-weight-bold">Point Kanan</label>
											<span class="cl-secondary font-size-10">{{ netGrowth.netgrow_master_node_right | toNumber }}</span>
										</div>

										<div class="d-flex justify-space-between align-start mb-1">
											<label class="cl-black font-size-9 font-weight-bold">Menunggu Kiri</label>
											<span class="cl-black font-size-10">{{ netGrowth.netgrow_master_wait_left | toNumber }}</span>
										</div>

										<div class="d-flex justify-space-between align-start mb-1">
											<label class="cl-secondary font-size-9 font-weight-bold">Menunggu Kanan</label>
											<span class="cl-secondary font-size-10">{{ netGrowth.netgrow_master_wait_right | toNumber }}</span>
										</div>

										<div class="d-flex justify-space-between align-start mb-1">
											<label class="cl-black font-size-9 font-weight-bold">Pasangan</label>
											<span class="cl-black font-size-10">{{ netGrowth.netgrow_master_match_real | toNumber }}</span>
										</div>

										<div class="d-flex justify-space-between align-start mb-1">
											<label class="cl-secondary font-size-9 font-weight-bold">Unilevel</label>
											<span class="cl-secondary font-size-10">{{ netGrowth.netgrow_master_unilevel | toNumber }}</span>
										</div>

										<div class="d-flex justify-space-between align-start mb-1">
											<label class="cl-black font-size-9 font-weight-bold">Sponsor</label>
											<span class="cl-black font-size-10">{{ netGrowth.netgrow_master_sponsor | toNumber }}</span>
										</div>
									</v-col>
								</v-row>
							</v-card>
						</template>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="listNetGrowth.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada data pertumbuhan jaringan yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div v-if="listNetGrowth.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="netGrowthPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ netGrowthPagination.total_display }} data dari total {{ netGrowthPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="mt-4" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
	components: {
	},
	data() {
		return {
			loading: false,
			startDate: false,
			endDate: false,
			dateStart: null,
			dateEnd: null,
			start: '',
			end: '',
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
		}
	},
	computed: {
		...mapState('network', ['listNetGrowth', 'netGrowthPagination', 'netGrowthToday']),
	},
	methods: {
		...mapActions('network', ['getNetGrowth', 'getNetGrowthToday']),

		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		seacrhHistory() {
			this.page = 1
			this.getData()
		},
		resetHistory() {
			this.start = ''
			this.end = ''
			this.setDefaultRange()
			this.page = 1
			this.limit = '10'
			this.getData()
		},
		setDefaultRange() {
			this.start = moment().format("YYYY-MM-01");
			this.end = moment().subtract(1, "days").format("YYYY-MM-DD");
		},
		getData() {
			this.loading = true
			let params = {limit:this.limit, page: this.page}

			this.getNetGrowthToday()
			if (this.dateStart) {
				params.start = this.dateStart
			}
			if (this.start) {
				params.start = this.start
			}
			if (this.dateEnd) {
				params.end = this.dateEnd
			}
			if (this.end) {
				params.end = this.end
			}
			this.getNetGrowth(params).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Pertumbuhan Jaringan`)
		this.getData()
	}
};
</script>

